import { afterCallstack } from '../utils/utils.js';

class AnnouncementBar extends HTMLElement {
    constructor() {
        super();
        this.slider = null;
        this.sliderElement = this.querySelector('[data-announcement-slider]');
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    }

    connectedCallback() {
        if (!this.sliderElement) return;

        this.handleBreakpointChange();
        window.addEventListener('on:breakpoint-change', this.handleBreakpointChange);
    }

    disconnectedCallback() {
        window.removeEventListener('on:breakpoint-change', this.handleBreakpointChange);
        this.destroySlider();
    }

    initSlider() {
        if (!this.sliderElement) return;

        const slides = this.sliderElement.children;
        if (slides.length <= 2) return; // Don't initialize slider if 2 or fewer slides

        // Destroy existing slider if it exists
        this.destroySlider();

        // Initialize new slider
        this.slider = new Flickity(this.sliderElement, {
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            autoPlay: 3000
        });
    }

    destroySlider() {
        if (this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    handleBreakpointChange() {
        if (!theme.mediaMatches.md) {
            afterCallstack(() => this.initSlider());
        } else {
            afterCallstack(() => this.destroySlider());
        }
    }
}

customElements.define('announcement-bar', AnnouncementBar);
